import { render, staticRenderFns } from "./AppNavigationDrawerElement.vue?vue&type=template&id=42067af8"
import script from "./AppNavigationDrawerElement.vue?vue&type=script&lang=js"
export * from "./AppNavigationDrawerElement.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationDrawerElement.vue?vue&type=style&index=0&id=42067af8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports